module.exports = __webpack_public_path__ + "img/purple-header-en.9ee67621.png";